module.exports = __webpack_public_path__ + "static/media/btn_fruits.a68e8d15.png";